import { worklistNextWork } from './worklistNextWork.js'
import { splitParentSummary } from './splitParentSummary.js'
import styles from './pursuit.module.css'
/** Opens only an exact, unique ID present in the current authorized plane. */
export default function SplitParentReview({ record, universe = [], onOpen }) {
  const isGroup=record?.isIndyGroup === true
  const groupMembers=Array.isArray(record?.memberRecords) ? record.memberRecords : []
  const uniqueIds=[...new Set(groupMembers.map(member=>String(member?.id || '')).filter(id=>id&&!id.startsWith('indy:')))]
  const summary = isGroup ? {complete:false,headline:'Review actual individual winner records',note:'This is a synthetic grouping, not a championship or a separate crown. Only actual member records in the current authorized view can be opened.',reasons:[],children:uniqueIds.map(id=>({id,label:'individual member'}))} : splitParentSummary(record)
  if (!summary) return null
  const byId = new Map()
  for (const child of universe || []) {
    const id = String(child.id || '')
    if (id) byId.set(id, byId.has(id) ? null : child)
  }
  return <section aria-label="Split family reconciliation">
    <h3>{summary.complete ? 'Matched split records. Review current evidence' : summary.headline}</h3><p>{summary.note}</p>
    {summary.reasons.length > 0 && <ul>{summary.reasons.map(reason => <li key={reason}>{reason}</li>)}</ul>}
    {summary.children.length > 0 ? <ul aria-label="Matched child records">
      {summary.children.map(child => {
        const loaded = byId.get(child.id)
        const work = loaded ? worklistNextWork(loaded) : null
        return <li key={child.id}>
          {loaded && onOpen ? <button type="button" className={styles.workOpen} onClick={() => onOpen(loaded)}>
            Open matched {child.label}: {loaded.name || child.id}
          </button> : <span>{child.label} ({child.id}). Current child record unavailable; no navigation offered.</span>}
          {work && <p>Current record: {work.champion}. Review this child’s source evidence.</p>}
        </li>
      })}
    </ul> : <p>No unambiguous matched child links are available in this read.</p>}
  </section>
}
